export default __webpack_public_path__ + "static/media/lost.ac6674b3.svg";